import React, { Component } from "react";
import { connect } from "react-redux";
// import { Input, FormFeedback } from "reactstrap";
import { withRouter } from "react-router";

import api from "../../config/api";
import historyAction from "../../redux/history/action";
import rsaAction from "../../redux/rsaPinDublicated/action";
import InputComp from "../../component/InputComp/InputComp";
import constants from "../../config/constants";

class Residence extends Component {
  state = {
    allStates: [],
    allLGA: [],
    pathname: "",
  };

  componentDidMount() {
    const { customRef, history, setHistory } = this.props;

    this.setState({
      pathname: history.location.pathname,
    });
    this.fetchState(null, true);

    customRef({ validate: this.validate });
    setHistory(history);
  }

  fetchState = async (residenceCountryCode, dontClear) => {
    try {
      const { token, setResidenceField, residenceStateCode } = this.props;

      if (!dontClear) {
        setResidenceField({ residenceStateCode: "", residenceLGACode: "" });
      }

      if (residenceStateCode) {
        this.fetchLGA(null, true);
      }

      this.setState({ allStates: [], allLGA: [] });

      if (!residenceCountryCode) {
        residenceCountryCode = this.props.residenceCountryCode;
      }

      const state = await api.fetchState(
        { countryCode: residenceCountryCode },
        token
      );

      this.setState({ allStates: state.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  fetchLGA = async (residenceStateCode, dontClear) => {
    try {
      const { token, setResidenceField } = this.props;

      if (!dontClear) {
        setResidenceField({ residenceLGACode: "" });
      }

      this.setState({ allLGA: [] });

      if (!residenceStateCode) {
        residenceStateCode = this.props.residenceStateCode;
      }

      const LGA = await api.fetchLGA({ stateCode: residenceStateCode }, token);

      this.setState({ allLGA: LGA.data.result });
    } catch (e) {
      console.log("E =>", e);
    }
  };

  onSelectChange = (e) => {
    const { setResidenceField } = this.props;

    setResidenceField({ [e.target.name]: e.target.value });

    if (e.target.name === "residenceCountryCode") {
      this.fetchState(e.target.value);
    }

    if (e.target.name === "residenceStateCode") {
      this.fetchLGA(e.target.value);
    }
  };

  validate = () => {
    const { email, permZip, confirmEmail } = this.props;

    let isValidated = true,
      confirmEmailError = "",
      permBoxError = "",
      permZipError = "";
    // residenceHouseNoError = "";
    //   residenceStateCodeError = "",
    //   residenceLGACodeError = "";

    // if (!residenceStateCode) {
    //   residenceStateCodeError = "This field is required";
    //   isValidated = false;
    // }
    // if (!residenceLGACode) {
    //   residenceLGACodeError = "This field is required";
    //   isValidated = false;
    // }
    // if (!permBox) {
    //   permBoxError = "This field is required";
    //   isValidated = false;
    // }

    if (this.state.pathname === constants.RSA_PIN_2_PATH) {
      if (email) {
        if (confirmEmail !== email) {
          confirmEmailError = "Email and Confirm Email must be same";
          isValidated = false;
        }
      }
    }

    // if (!residenceHouseNo) {
    //   residenceHouseNoError = "This field is required";
    //   isValidated = false;
    // }

    if (!permZip) {
      permZipError = "This field is required";
      isValidated = false;
    }
    this.setState({
      // residenceStateCodeError,
      // residenceLGACodeError,
      permBoxError,
 
      confirmEmailError,
      // residenceHouseNoError,
      permZipError,
    });

    return isValidated;
  };

  render() {
    const {
      // residenceCountryCode,
      setResidenceField,
      // residenceHouseNo,
      // residenceLGACode,
      // residenceStateCode,
      // residenceStreetName,
      // residenceTownCity,
      permZip,
      email,
      permanentAddress,
      permanentAddress1,
      permBox,
      confirmEmail,
      // countries
    } = this.props;

    const {
      emailError,

      confirmEmailError,
      permBoxError,
      // residenceHouseNoError,
      permZipError,
      // allStates,
      // allLGA,
      // residenceStateCodeError,
      // residenceLGACodeError
    } = this.state;

    return (
      <div>
        <InputComp
          type="text"
          value={permanentAddress}
          placeholder="Permanent Address of Account Holder"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setResidenceField({ permanentAddress: e.target.value });
          }}
        />
        {/* <InputComp
          type="text"
          value={residenceHouseNo}
          errorMessage={residenceHouseNoError}
          placeholder="Residence House Number/Name"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setResidenceField({ residenceHouseNo: e.target.value });
          }}
        /> */}
        <InputComp
          type="text"
          value={permanentAddress1}
          placeholder="Other Address Details"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setResidenceField({ permanentAddress1: e.target.value });
          }}
        />
        {/* <InputComp
          type="text"
          value={residenceStreetName}
          placeholder="Residence Street Name"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setResidenceField({ residenceStreetName: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={residenceTownCity}
          placeholder="Residence Town City"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setResidenceField({ residenceTownCity: e.target.value });
          }}
        />
        <Input
          className="margin-y-10"
          type="select"
          name="residenceCountryCode"
          id="exampleSelect"
          value={residenceCountryCode || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Residence Country Code*
          </option>
          {countries.map(item => (
            <option value={item.countryCode}>{item.countryName}</option>
          ))}
        </Input>
        <Input
          className="margin-y-10"
          type="select"
          name="residenceStateCode"
          invalid={!!residenceStateCodeError}
          id="exampleSelect"
          value={residenceStateCode || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Residence State Code*
          </option>
          {allStates.map(item => (
            <option value={item.stateCode}>{item.stateName}</option>
          ))}
        </Input>
        {!!residenceStateCodeError && (
          <FormFeedback invalid>{residenceStateCodeError}</FormFeedback>
        )}
        <Input
          className="margin-y-10"
          type="select"
          name="residenceLGACode"
          invalid={!!residenceLGACodeError}
          id="exampleSelect"
          value={residenceLGACode || "placeholder"}
          onChange={this.onSelectChange}
        >
          <option value="placeholder" disabled selected>
            Residence LGA Code*
          </option>
          {allLGA.map(item => (
            <option value={item.lgaCode}>{item.lgaName}</option>
          ))}
        </Input>
        {!!residenceLGACodeError && (
          <FormFeedback invalid>{residenceLGACodeError}</FormFeedback>
        )} */}
        {/* <InputComp
          type="text"
          value={residenceLGACode}
          placeholder="Residence LGA Code"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setResidenceField({ residenceLGACode: e.target.value });
          }}
        /> */}
        {/* <InputComp
          type="text"
          value={residenceStateCode}
          placeholder="Residence State Code"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setResidenceField({ residenceStateCode: e.target.value });
          }}
        /> */}
        {/* <InputComp
          type="text"
          value={residenceCountryCode}
          placeholder="Residence Country Code"
          containerStyles={{ width: "100%" }}
          onChange={e => {
            setResidenceField({ residenceCountryCode: e.target.value });
          }}
        /> */}
        <InputComp
          type="text"
          value={permZip}
          placeholder="Zip"
          errorMessage={permZipError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setResidenceField({ permZip: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={email}
          placeholder="Email"
          errorMessage={emailError}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setResidenceField({ email: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={confirmEmail}
          placeholder="Confirm Email"
          errorMessage={confirmEmailError}
          hidden={this.state.pathname !== constants.RSA_PIN_2_PATH}
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setResidenceField({ confirmEmail: e.target.value });
          }}
        />
        <InputComp
          type="text"
          value={permBox}
          errorMessage={permBoxError}
          inputContainerClasses="mb-2"
          placeholder="P. O. Box of Account Holder"
          containerStyles={{ width: "100%" }}
          onChange={(e) => {
            setResidenceField({ permBox: e.target.value });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.rsaPinDublicated.residence,
  token: state.rsaPinDublicated.token,
  countries: state.onboarding.countries,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setResidenceField: rsaAction.setResidenceField,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Residence));
